// Bridge to the Flutter webview host. The Vibration channel is only present
// inside the native app wrapper; on web this call no-ops.
export function vibrate(type = 'default') {
    if (type === 'default') {
        window.Vibration?.postMessage('vibrate');
    }
    else {
        window.Vibration?.postMessage(type);
    }
}
